import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from '../Global';
// import $ from "jquery";
const ProductionsInventoryGroupByDateLocation = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});


  useEffect(() => {
        setPermission(FindModuleById(445)); 
    console.log(permission);

    axios
      .get(`/productions-inventories/listing-groupby-all-with-type/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        // setData(response.data.data.inventories);
        setValue(response.data.data.productions);
        setData(response.data.data.productions_all);

      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

 

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


   
  // const columns =
  // [
   
  //     {
  //       header: 'Barcode Number',
  //       accessorFn: (row) => `${row.barcode_number}`,
  //       Cell: ({ renderedCellValue, row }) => {        
       
  //             return(
  //               <a href={'/production-output-view/'+row.original.id} className=""  >
  //                  {row.original.barcode_number}
  //               </a>
                
  //             )
  //           }
  //     },

 
  //   {
  //     accessorKey: 'shift', //normal accessorKey
  //     header: 'Shift',
  //   },
  //   {
  //     accessorKey: 'shift_date', //normal accessorKey
  //     header: 'Shift Date',
  //   },
 
  //   {
  //     header: 'Total Net Weight',
  //     //accessorFn: (row) => `${row.barcode_number}`,
  //     Cell: ({ renderedCellValue, row }) => {  
  //       var data_count =  row.original.items;
  //       const totalNetWeight = data_count.length > 0 ? data_count.reduce((acc, item) => acc + item.net_weight, 0) : 0;
  //           return(
  //             <div>{totalNetWeight}</div>
  //           )
  //         }
  //   },
 
  //   {
  //     header: 'Package Type',
  //     accessorFn: (row) => `${(row.package_type)?row.package_type.title:""} `,
  //   },
  
  //   {
  //     header: 'Created By',
  //     accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
  //   },
  //   {
  //     header: 'Updated By',
  //     accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
  //   },
  //  ];
  // ✅ Total Net Weight Cell Component
const TotalNetWeightCell = ({ row }) => {
  const items = row.original.items || []; // Ensure items exist
  const totalNetWeight = items.length > 0
    ? items.reduce((acc, item) => acc + (item.net_weight || 0), 0)
    : 0;

  return <div>{totalNetWeight.toFixed(2)}</div>; // Format to 2 decimal places
};

TotalNetWeightCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          net_weight: PropTypes.number, // Ensure net_weight is a number
        })
      ),
    }).isRequired,
  }).isRequired,
};
const BarcodeCell = ({ row }) => (
  <a href={`/production-output-view/${row.original.id}`} className="">
    {row.original.barcode_number}
  </a>
);

// Define PropTypes
BarcodeCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      barcode_number: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
// ✅ Define Columns
const columns = [
  {
    header: 'Barcode Number',
    accessorFn: (row) => `${row.barcode_number}`,
    Cell: BarcodeCell, // Use the functional component
  },
  {
    accessorKey: 'shift',
    header: 'Shift',
  },
  {
    accessorKey: 'shift_date',
    header: 'Shift Date',
  },
  {
    header: 'Total Net Weight',
    Cell: (props) => <TotalNetWeightCell {...props} />, // ✅ Use new component
  },
  {
    header: 'Package Type',
    accessorFn: (row) => (row.package_type ? row.package_type.title : ''),
  },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}`.trim() : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}`.trim() : '',
  },
];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Inventories Group By Date Location  Pallet Type</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/productions-inventories">Production Inventories</Link>
                    </li>
                    <li className="breadcrumb-item active">Production Inventories Group By Date Location  Pallet Type</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Production Inventories Group By  Date Location  Pallet Type</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3"> Date</th>
                        <td className="p-3">{value.date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location ? value.location_name.title : ""}
                        </td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Pallet Type</th>
                        <td className="p-3">
                          {value.pallet_type_title ? value.pallet_type_title.title : ""}
                        </td>
                      </tr>

                      </table>
                   
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Production Inventories Group By Date Location  Pallet Type </h4>
                    <div className="table-responsive">
                    <MaterialReactTable columns={columns} data={data} 
                            enableColumnOrdering
                            enablePinning
                          
                          />
                        </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionsInventoryGroupByDateLocation;
